import React from 'react';
import classnames from 'classnames'
import Component from './route-component';
import Enhance from '../core/enhance';
/**
 *
 */
class RouteModal extends Component {
    state = {};

    constructor(props) {
        super(props);
    }

    /**
     *
     * @return {*}
     */
    render() {
        return (
            <div className="c-route-modal"></div>
        )
    }
}

Enhance(RouteModal, {}, 'RouteModal');
export default RouteModal;
